import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApolloSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_3598_400215)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2,
			width: 42,
			height: 42,
			rx: 5.25,
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M29.8722 30.0571C30.1223 30.8044 30.2783 31.3659 30.2783 31.7079C30.2783 32.019 29.8413 32.2062 29.1865 32.2681L28.2815 32.3624C28.0637 32.5172 28.0933 33.0154 28.3447 33.1393C29.2497 33.1083 30.4343 33.0464 31.9322 33.0464C33.336 33.0464 34.4292 33.0774 35.7079 33.1407C35.8639 33.0154 35.9271 32.5172 35.7079 32.361L34.8662 32.2681C33.5242 32.1119 33.1182 31.646 32.2132 28.9691L27.9373 16.4517C27.4707 15.0822 26.9705 13.6509 26.5658 12.2801C26.5026 12.0619 26.2821 12 26.0979 12C25.7536 12.404 25.2238 12.9655 24.4749 13.1836C24.569 13.6818 24.3808 14.273 23.9438 15.3933L20.761 23.7997C19.4514 27.2873 18.5774 29.3098 18.0153 30.7425C17.5783 31.8628 16.8925 32.2062 16.1436 32.2681L15.1136 32.3624C14.9253 32.5172 14.9885 33.0154 15.1754 33.1393C16.0185 33.1083 17.1413 33.0464 18.1713 33.0464C19.6383 33.0774 20.6051 33.0774 21.4172 33.1407C21.6982 33.0154 21.6982 32.5172 21.4791 32.361L20.4491 32.2681C19.7001 32.2062 19.5441 32.019 19.5441 31.646C19.5441 31.3026 19.7633 30.4624 20.2299 29.0606L21.3231 25.7926C21.5423 25.1382 21.7292 25.0453 22.509 25.0453H27.2206C28.1565 25.0453 28.2829 25.1395 28.5007 25.8236L29.8722 30.0571ZM24.2893 17.6353C24.6322 16.7008 24.9442 15.9534 25.0383 15.7986H25.1001C25.2884 16.1716 25.5681 17.0132 25.8182 17.7591L27.503 22.8356C27.784 23.6758 27.7208 23.7997 26.8172 23.7997H22.9756C22.1016 23.7997 22.0707 23.7687 22.3208 23.0524L24.2866 17.6353H24.2893Z",
			fill: "#007B63"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_3598_400215",
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_3598_400215"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_3598_400215",
				result: "shape"
			})
		]
	}) })]
});
export default SvgApolloSm;
